// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9175) return "static/chunks/9175-32761b3b08f0295d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"15":"7d9e8f79e2c845c9","791":"91dadc545e9dc31c","3627":"b11a9b7888f48b06","3850":"3536950d485a86e4","6350":"f1151ef2b45038dc"}[chunkId] + ".js";
};